
import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`;

const moveBackground = keyframes`
    from {
        background-position: 0 0;
    }

    to {
        background-position: 100% 100%;
    }
`;

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(26,26,64,1) 50%, rgba(0,212,255,1) 100%);
    background-size: 400% 400%;
    animation: ${moveBackground} 10s ease infinite;
`;

const Text = styled.h1`
    font-size: 3rem;
    text-align: center;
    animation: ${fadeIn} 1s ease-in-out;

    &:hover {
        animation: ${fadeIn} 1s ease-in-out, ${moveBackground} 10s ease infinite;
    }
`;

const Desktop = () => {
    return (
        <Container>
            <Text>
            ¿Quieres gradear cartas TCG? Porfavor usa una computadora para ver este sitio en su totalidad
            </Text>
        </Container>
    );
};

export default Desktop;
